import { createFileRoute } from '@tanstack/react-router'

import { OnboardPage } from '~/boundedContext/settings/pages/onboard'

export const Route = createFileRoute('/_centered-layout/onboard')({
  component: OnboardPage,
})
